import { useDispatch, useSelector } from "react-redux";
import { setSessionExpired, setSpinnerLoading } from "../utility/Redux/modal";
import { useState } from "react";
import { selectToken } from "../utility/Redux/security";
import { useEffect } from "react";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import MasterHelp from "../utility/component/modals/masterHelp";
import { CallAPIPromise, mobileViewWidth } from "../billing/common";
import CustomerModal from "../masters/customer-master/customerModal";
import EmptyModal from "./freeModal";
import { CustomerMaster } from "../masters";

const CustomerMasterHelp = ({ onRowClick, status, onClose }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    // Change the shadow color
    overflow: "hidden",
    backgroundColor: "white",
  };

  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(1);
  const prefix = useSelector(selectPrefix);
  const [masterStatus, setMasterStatus] = useState(false);

  const width = useSelector(selectWidth);
  const columns = [
    {
      width:
        width <= 768
          ? 80
          : width <= 1024
          ? 85
          : width <= 1280
          ? 80
          : width <= 1440
          ? 80
          : 60,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_CODE",
      renderHeader: (params) => <div>Code</div>,
    },
    {
      width:
        width <= 768
          ? 130
          : width <= 1024
          ? 145
          : width <= 1280
          ? 130
          : width <= 1440
          ? 200
          : 200,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_NAME",
      renderHeader: (params) => <div>Customer Name</div>,
    },

    {
      width: 100,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },
    {
      width:
        width <= 768
          ? 180
          : width <= 1024
          ? 150
          : width <= 1280
          ? 130
          : width <= 1440
          ? 200
          : 200,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_ADDRESS",
      renderHeader: (params) => <div>Address</div>,
    },
    {
      width: 70,
      headerAlign: "center",
      align: "left",
      field: "DISQ_RATE",
      renderCell: (p) => {
        return <div>{p.value > 0 ? `${p.value}%` : ""}</div>;
      },
      renderHeader: (params) => <div>Disq. Rate</div>,
    },
  ];

  const mobileColumns = [
    {
      width: 120,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_NAME",
      renderHeader: (params) => <div>Customer Name</div>,
    },

    {
      width: 110,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },
    {
      width: 100,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_ADDRESS",
      renderHeader: (params) => <div>Address</div>,
    },
  ];
  const [searchQuery, setSearchQuery] = useState("");
  const [fullList, setFullList] = useState([]);

  useEffect(() => {
    if (searchQuery) {
      const regex = /\d+/;

      if (searchQuery) {
        if (regex.test(searchQuery.substring(0, 1))) {
          getData(1, searchQuery);
        } else {
          getData(1, "", searchQuery);
        }
      } else {
        getData(1);
      }
    } else {
      getData(1);
    }
  }, [searchQuery]);

  const dispatch = useDispatch();

  const getData = async (page, mobile, name) => {
    dispatch(setSpinnerLoading("Loading"));
    const data = {
      table_prefix_master: prefix.replace(/_.+_/, "_"),
      CUSTOMER_MOBILE: mobile ? mobile : "",
      CUSTOMER_NAME: name ? name : "",
      page: page ? page : currentPage,
      PAGE: page ? page : currentPage,

    };
    CallAPIPromise("/api/customerMasterUtils/listCustomerMaster", data, token)
      .then((p) => {
        if (!p.data.error) {
          let list = [];
          const data = p.data.response;
          settotalPages(p.data.pagination.totalPages);

          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
            });
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      setCurrentPage(1);
      getData();
    }
  }, [status]);

  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            onClose();
            setRows([]);
            setSearchQuery("");
          }}
          totalPages={totalPages}
          title={"Customer Master | Help"}
          columns={width > mobileViewWidth ? columns : mobileColumns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onRowClick={(p) => {
            onRowClick(p);
            setRows([]);
            setSearchQuery("");
          }}
          onChangePagination={(page) => {
            getData(page);
            setCurrentPage(page);
          }}
          CreateNew={() => {
            setMasterStatus(true);
          }}
          currentPage={currentPage}
          hideFooter={true}
        />

        <EmptyModal
          status={masterStatus}
          onClose={() => {
            setMasterStatus(false);
          }}
          Component={CustomerMaster}
          afterCreate={() => {
            setMasterStatus(false);
            getData();
          }}
        />
      </div>
    </>
  );
};

export default CustomerMasterHelp;
